export default __webpack_public_path__ + "static/video-c0e9dac8f11068fb60fc191b9898aebf.mp4";